import React from 'react';
import ListingOne from '../components/HomeListing/ListingOne';
import ListingOneImg from '../components/HomeListing/ListingOneImg';
import ListingThree from '../components/HomeListing/ListingThree';
import ListingTwo from '../components/HomeListing/ListingTwo';
import Mantra18 from '../components/HomeListing/Mantra18';
import MyMantra from '../components/HomeListing/MyMantra';
import PmviewCard from '../components/HomeListing/PmviewCard';
import { imgUrl } from "../utils/url";
import HomeSlider from '../components/HomeListing/HomeSlider';
import { getUrlParameter, translation, getUserDetail, postData } from '../utils/helper';
import $ from 'jquery';
import { bootstrap, appclient, urlparams } from '../config/bootstrap';
import { userDetailStore, translationStore } from '../config/store';
import CleverTapSdk from '../utils/CleverTapSdk';
import NativeShare from './common/NativeShare';

export default class LandingPage extends React.Component {

    constructor() {
        super();
        this.state = {
            blocks: {},
            type: 'student',
            allData: {},
            mantracount: null,
            activePage: 0,
            user: null,
            loadpage: false
        }
    }
    async componentDidMount() {
        var ref = this;




        //do language processing
        var language = getUrlParameter("lang");

        // if (language != null && language != "en") {
        //     $.get("/" + language + ".json", function (data) {
        //         translationStore.dispatch({ "type": "TRANSLATION", "data": data })
        //         ref.setState({ loadpage: true })
        //     })
        // } else {
        //     this.setState({ loadpage: true })
        // }



        $.get("/mantra.json", function (data) {
            console.log(data);

            let student = window.location.hostname.indexOf('localhost') != -1 ? data['student'] : data.student;
            // let parent = window.location.hostname.indexOf('localhost') != -1 ? data['parent'] : JSON.parse(data).parent;
            // let all = { ...student, ...parent }

            ref.setState({ blocks: student, allData: data }, () => {
                if (localStorage.getItem('navigate')) {
                    let id = localStorage.getItem('navigate')
                    setTimeout(() => {
                        try {

                            document.getElementById("navigate_" + id).scrollIntoView({ inline: "center", block: "center" });

                            setTimeout(() => {
                                localStorage.removeItem('navigate');
                            }, 500)
                        } catch (error) {

                        }

                    }, 500)
                }
            });

        })

        //        ref.openSlide( ref );

        getUserDetail(ref);
        ref.setState({ "user": userDetailStore.getState().userDetail })
        userDetailStore.subscribe(() => {

            var user = userDetailStore.getState();

            ref.setState({ "user": user.userDetail })

            // ref.openSlide(ref)
        });

        // this.masonry.on( 'layoutComplete', () => { alert( 'asdasd' ) } );
        let data = await postData({}, 'mantracountv2', "noloader");
        this.setState({ mantracount: data })
        // console.log("data", data)

    }
    setTab = (type) => {
        let { allData } = this.state;
        if (typeof allData === "string") {
            allData = JSON.parse(allData);
        }
        let data = null;
        if (type == 'all') {
            let student = allData['student'];
            let parent = allData['parent'];
            let all = { ...student, ...parent }
            data = all;
        } else {
            data = allData[type]
        }

        try {
            let ctdata = {};
            ctdata["examwarriorsv2_action"] = "TabClicked";
            ctdata["tab"] = type;
            // CleverTapSdk.handleEventtracking(ctdata);
        } catch (er) { }

        this.setState({ blocks: {} }, () => {
            setTimeout(() => {
                this.setState({ blocks: data, type })
            }, 50)
        })
    }

    render() {
        const { blocks, type } = this.state;
        // console.log(blocks);
        return (
            <div className="home_section">

                <HomeSlider />
                <div className="ex_tabs_wrp">
                    {/* <h4 onClick={() => { this.setTab('all') }} className={type == 'all' ? "ex_tabs active" : "ex_tabs"}>All Mantras</h4> */}
                    <h4 onClick={() => { this.setTab('student') }} className={type == 'student' ? "ex_tabs active" : "ex_tabs"}>For Students</h4>
                    <h4 onClick={() => { this.setTab('parent') }} className={type == 'parent' ? "ex_tabs active" : "ex_tabs"}>For Parents</h4>
                    <h4 onClick={() => { this.setTab('teacher') }} className={type == 'teacher' ? "ex_tabs active" : "ex_tabs"}>Letter to Teachers</h4>
                </div>

                {/*teachers tab*/}

                {/*teachers tab*/}

                <div className="container">
                    <section className="mantra_cards_arp">
                        <div className="row">
                            {
                                blocks && Object.keys(blocks).length > 0 && Object.keys(blocks).map((key, index) => {
                                    if (blocks[key].home != 'false') {


                                        if (blocks[key].v_type == 'small') {
                                            return (
                                                <ListingOne data={blocks[key]} module={key} key={index} mantracount={this.state.mantracount} />
                                            )
                                        } else if (blocks[key].v_type == 'medium') {
                                            return (
                                                <ListingTwo data={blocks[key]} module={key} key={index} mantracount={this.state.mantracount} />
                                            )
                                        } else if (blocks[key].v_type == 'one_img') {
                                            return (
                                                <ListingOneImg data={blocks[key]} module={key} key={index} mantracount={this.state.mantracount} />
                                            )
                                        } else if (blocks[key].v_type == 'card') {
                                            return (
                                                <PmviewCard data={blocks[key]} module={key} key={index} mantracount={this.state.mantracount} />
                                            )

                                        } else if (blocks[key].v_type == 'certificate') {
                                            return (
                                                <Mantra18 data={blocks[key]} module={key} key={index} mantracount={this.state.mantracount} />
                                            )
                                        } else if (blocks[key].v_type == 'large') {
                                            return (
                                                <ListingThree data={blocks[key]} module={key} key={index} mantracount={this.state.mantracount} />
                                            )
                                        } else if (blocks[key].v_type == 'letter') {
                                            return (
                                                <React.Fragment key={index}>
                                                    <section className="hometab_img_wrp">
                                                        <img src={blocks[key].image[0]} className="hometab_img" />

                                                        <div className="tchrshtxt">Share this message with Friends and Family </div>
                                                        <NativeShare
                                                            sharedata={{
                                                                image: imgUrl + blocks[key].image[0],
                                                                text: blocks[key].inner_text,
                                                                postid: key ? key : "",
                                                            }}
                                                        >
                                                            <div className="preview_btn2">
                                                                <a href="#">Share</a>
                                                            </div>
                                                        </NativeShare>
                                                    </section>

                                                </React.Fragment>
                                            )
                                        }
                                    }

                                })
                            }
                            {
                                type != 'teacher' &&
                                <MyMantra />
                            }



                        </div>
                    </section>
                    {/* <PmviewCard />
                    <Mantra18 />
                    <MyMantra /> */}








                </div>
            </div>
        )
    }
}



